import React from "react";
import { Box } from "@chakra-ui/react";

import { StarProps } from "../../interface/interface";

const Stars: React.FC<StarProps> = ({ count, Icon, color }) => {
  const stars = Array(count)
    .fill("")
    .map((_, index) => <Box key={index} as={Icon} color={color} />);

  return <>{stars}</>;
};

export { Stars };
